import { userSlice } from '@wellesley/user'
import { useSelector } from 'react-redux'
import { authSlice } from '@wellesley/auth'
import { UserFull } from '@wellesley/openapi'
import useLocalFollowersInfinite from './useLocalFollowersInfinite'
import useRemoteFollowersInfinite from './useRemoteFollowersInfinite'

type HookProps = {
  skip?: boolean
  user?: UserFull
}

/**
 * Hook for fetching followers with infinite scroll/pagination.
 * Use useFollowers for simple first-page fetch.
 */
const useFollowersInfinite = ({ user, skip = false }: HookProps) => {
  const myUser = useSelector(userSlice.selectors.selectCurrentUser)
  const isLogged = useSelector(authSlice.selectors.selectIsAuthenticated)
  const canFetch = !skip && isLogged

  const remoteUserName =
    user && !user.local && user.domain
      ? `@${user.username}@${user.domain}`
      : undefined

  const isRemoteUser = !!remoteUserName
  const userIdToFetch = user?.id || myUser?.id

  const localResult = useLocalFollowersInfinite({
    userId: userIdToFetch,
    skip: !canFetch || isRemoteUser,
  })

  const remoteResult = useRemoteFollowersInfinite({
    userNameFull: remoteUserName,
    skip: !canFetch || !isRemoteUser,
  })

  return isRemoteUser ? remoteResult : localResult
}

export default useFollowersInfinite
